import { Component, ChangeDetectionStrategy} from '@angular/core';
import { TooltipService } from './tooltip.service';

@Component({ standalone: false,
    selector: 'tooltip-container',
    template: `
      <div class="tooltip-container">
        @if (tooltip) {
          <tooltip
            [title]="tooltip.title"
            [position]="tooltip.position"
            [ref]="tooltip.ref"
            [event]="tooltip.event"
            [useTruncationParent]="tooltip.useTruncationParent"
            [verticalOffset]="tooltip.verticalOffset"
            [horizontalOffset]="tooltip.horizontalOffset"
            [_width]="tooltip._width"
            [class]="tooltip.class">
          </tooltip>
        }
      </div>
      `,
    changeDetection: ChangeDetectionStrategy.Eager
  })
  export class TooltipContainerComponent {  
    tooltip: any = null;

    constructor(private tts: TooltipService) { 
      this.tts.getComponents().subscribe((tt) => {
        this.tooltip = tt;
      });
    }  
  }
